import {Amplify} from 'aws-amplify'

const {VUE_APP_AWS_REGION, VUE_APP_COGNITO_IDENTITY_POOL_ID, VUE_APP_COGNITO_USER_POOL_ID, VUE_APP_COGNITO_CLIENT_ID} =
  process.env

console.log('🔧 Amplify Config - Configuring with dual authentication support...')

// Amplify v6 configuration supporting both User Pool and Identity Pool authentication
const config = {
  Auth: {
    Cognito: {
      region: VUE_APP_AWS_REGION,

      // User Pool configuration (for email/password authentication)
      userPoolId: VUE_APP_COGNITO_USER_POOL_ID,
      userPoolClientId: VUE_APP_COGNITO_CLIENT_ID,

      // Identity Pool configuration (for OIDC authentication via custom provider)
      identityPoolId: VUE_APP_COGNITO_IDENTITY_POOL_ID,
      allowGuestAccess: false, // Disabled to prevent "Identity forbidden" errors when auth expires

      loginWith: {
        email: true,
        username: false,
      },
      signUpVerificationMethod: 'code',
      userAttributes: {
        email: {
          required: true,
        },
      },
      passwordFormat: {
        minLength: 8,
        requireLowercase: true,
        requireUppercase: true,
        requireNumbers: true,
        requireSpecialCharacters: true,
      },
    },
  },
}

Amplify.configure(config)
